import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
class Busy extends PureComponent {
    render() {
        if (!this.props.isBusy) {
            return null;
        }
        return (_jsxs("span", { children: [_jsx("span", { className: "fas fa-circle-notch fa-spin", "aria-hidden": "true" }), _jsx("span", { className: "sr-only", "aria-busy": "true", children: "Loading" })] }));
    }
}
Busy.defaultProps = {
    isBusy: true,
};
export default Busy;
